import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IntervalService {

  private static intervalRegistry = {};

  constructor() {
  }

  public static set(id, callback, timeout) {
    if (IntervalService.intervalRegistry[id]) {
      clearInterval(IntervalService.intervalRegistry[id]);
    }
    IntervalService.intervalRegistry[id] = setInterval(() => {
      callback();
    }, timeout);
  }

  public static clear(id) {
    clearInterval(IntervalService.intervalRegistry[id]);
    delete IntervalService.intervalRegistry[id];
  }
}
